import { render, staticRenderFns } from "./Gamepad.vue?vue&type=template&id=67baa55d&scoped=true&"
import script from "./Gamepad.vue?vue&type=script&lang=js&"
export * from "./Gamepad.vue?vue&type=script&lang=js&"
import style0 from "./Gamepad.vue?vue&type=style&index=0&id=67baa55d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67baa55d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
